import { useOpenAgentSecretsSettings } from "@ext/agent/components/utils/openAgentSecretsSettings";
import type { ReactNode } from "react";

export const AgentSecretsSettingsLink = ({ children }: { children: ReactNode }) => {
	const openSecretsSettings = useOpenAgentSecretsSettings();

	return (
		<button className="link" onClick={openSecretsSettings} type="button">
			{children}
		</button>
	);
};
